<template>
  <v-row dense>
    <v-col>
      <v-row>
        <v-col>
          <v-text-field
            label="Busca"
            v-model="filter"
            outlined
            dense
            hide-details
            append-icon="eva-search-outline"
            clearable
            background-color="white"
          />
        </v-col>

        <v-spacer />

        <v-col cols="auto">
          <v-dialog v-model="dialog" max-width="500px" @click:outside="close">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="light-blue" dark v-bind="attrs" v-on="on">
                Nova via de aplicação
              </v-btn>
            </template>

            <v-card>
              <v-card-title>
                <span class="headline">Nova via de aplicação</span>
              </v-card-title>

              <v-card-text>
                <v-container fluid>
                  <v-row dense>
                    <v-col cols="12">
                      <v-text-field
                        outlined
                        dense
                        v-model="applicationRoute.name"
                        label="Nome"
                        :hide-details="!errors.applicationRoute"
                        :error-messages="errors.applicationRoute"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">
                  Cancelar
                </v-btn>

                <v-btn color="blue darken-1" text @click="save"> Salvar </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>

      <v-row
        dense
        v-for="applicationRoute in filteredApplicationRoutes"
        :key="applicationRoute.id"
      >
        <v-col>
          <ApplicationRouteListItem
            :applicationRoute="applicationRoute"
            :refreshList="refreshList"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import ApplicationRouteListItem from "@/components/config/medicine/application_route/item/index.vue";

export default {
  name: "ApplicationRouteList",
  components: {
    ApplicationRouteListItem,
  },
  data() {
    return {
      errors: {},
      dialog: null,
      applicationRoute: {},
      filter: "",
    };
  },
  apollo: {
    medicineApplicationRoutes: {
      query: require("@/graphql/medicine/medicine_application_routes.gql"),
    },
  },
  computed: {
    filteredApplicationRoutes() {
      let applicationRoutes = this.lodash.orderBy(
        this.medicineApplicationRoutes,
        (e) => {
          return e.name
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
        },
        ["asc"]
      );

      if (this.filter) {
        applicationRoutes = this.lodash.filter(
          applicationRoutes,
          function (e) {
            return e.name
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .includes(
                this.filter
                  .toLowerCase()
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "")
              );
          }.bind(this)
        );
      }

      return applicationRoutes;
    },
  },
  methods: {
    close() {
      this.dialog = false;
      this.applicationRoute = {};
    },
    save() {
      if (!this.validate()) return;

      this.apolloMutate({
        mutation: require("@/graphql/medicine/save_application_route.gql"),
        variables: {
          applicationRouteId: "",
          name: this.applicationRoute.name,
        },
      }).then(() => {
        this.refreshList();

        this.$store.dispatch("createNotification", {
          message: "Cadastro salvo com sucesso.",
          type: "success",
        });
      });

      this.close();
    },
    refreshList() {
      this.$apollo.queries.medicineApplicationRoutes.refetch();
    },
    validate() {
      const errorMsg = "Esse campo deve ser preenchido.";
      this.errors = {};

      let name = this.applicationRoute.name;
      if (this.lodash.isEmpty(name?.trim())) {
        this.errors.applicationRoute = errorMsg;
      }

      if (Object.keys(this.errors).length === 0) {
        return true;
      }

      return false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
